import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'vehicleType', method: 'GET', body: null, token: token })
}
